import type { ScreenDef } from './types';

export const businessDevelopmentFields: ScreenDef = {
    image: 'Business Development',
    sections: [
        {
            name: 'Level of Support',
            entity: 'account',
            fields: [
                { field: 'lon_sales1stlinesupporteth' },
                { field: 'lon_sales1stlinesupportotc' },
                { field: 'lon_storegrade', labelOverride: 'BD Grade' },
                { field: 'lon_otcgrade' },
                { field: 'lon_bdpharmacytype' },
                { field: 'lon_bdrxsize', labelOverride: 'RX Size' },
                { field: 'lon_bdotcsize' },
                { field: 'lon_lastactivitydate' },
                { field: 'lon_openactivepriorities' },
                { field: 'lon_openactivepriorities_date', labelOverride: 'Last updated' },
                { field: 'lon_sales2ndlinesupporteth' },
                { field: 'lon_sales2ndlinesupportotc' },
                { field: 'lon_newbusinesstarget' },
                { field: 'lon_bdgeoprofile' },
                { field: 'lon_lastrepvisitrx' },
                { field: 'lon_lastrepvisitotc' },
                { field: 'bit_ipastrategicrangetype' },
            ],
        },
        {
            name: 'Contract',
            entity: 'account',
            fields: [
                { field: 'lon_bdundercontractrx' },
                { field: 'lon_contractstartdaterx' },
                { field: 'lon_bdcontractrenewaldaterx' },
                { field: 'lon_bdcurrentrxpricing' },
                { field: 'lon_bddatewon' },
                { field: 'lon_bdundercontractotc' },
                { field: 'lon_contractstartdateotc' },
                { field: 'lon_bdcontractrenewaldateotc' },
                { field: 'lon_bdcurrentotcpricing' },
                { field: 'lon_bddatelost' },
            ],
        },
    ],
};
